import { render, staticRenderFns } from "./DonationInvitesMain.vue?vue&type=template&id=159b4820&scoped=true&"
import script from "./DonationInvitesMain.vue?vue&type=script&lang=js&"
export * from "./DonationInvitesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159b4820",
  null
  
)

export default component.exports